/**
 * Skeleton Loader Component
 *
 * @package Enterprise\BookingSystem\Components
 */

/**
 * WordPress dependencies
 */
import { type CSSProperties, type ReactNode } from '@wordpress/element';

import './Skeleton.scss';

type SkeletonProps = {
	readonly children?: ReactNode;
	readonly height?: CSSProperties['height'];
	readonly loading?: boolean;
	readonly width?: CSSProperties['width'];
	readonly borderRadius?: CSSProperties['borderRadius'];
	readonly className?: string;
	readonly style?: CSSProperties;
};

export const Skeleton = ( {
	children,
	height,
	loading = true,
	width,
	borderRadius = '8px',
	className = '',
	style,
}: SkeletonProps ) => {
	if ( ! loading ) {
		return <>{ children }</>;
	}

	return (
		<div
			className={ `ebs-skeleton ${ className }`.trim() }
			style={ {
				height,
				width,
				borderRadius,
				...style,
			} }
			aria-hidden="true"
		/>
	);
};
